import api from './api';
import { getToken } from './auth';

export type StartCameraHlsResponse = {
  sessionId: string;
  manifestPath: string;
};

export async function startCameraHls(params: {
  establishmentId: string;
  channelId: string;
  deviceId?: number;
}): Promise<StartCameraHlsResponse & { manifestUrl: string }> {
  const response = await api.post<StartCameraHlsResponse>(
    `/app/cameras/${encodeURIComponent(params.establishmentId)}/channels/${encodeURIComponent(
      params.channelId
    )}/hls/start`,
    typeof params.deviceId === 'number' ? { deviceId: params.deviceId } : {}
  );

  const data = response.data;
  const manifestPath = String(data?.manifestPath ?? '').trim();
  const sessionId = String(data?.sessionId ?? '').trim();

  if (!manifestPath || !sessionId) {
    throw new Error('Invalid HLS response');
  }

  const token = getToken();
  const query = new URLSearchParams();
  if (token) query.set('token', token);
  query.set('t', String(Date.now()));

  const apiBaseUrl = String(process.env.REACT_APP_API_URL ?? '')
    .trim()
    .replace(/\/+$/, '');
  const absoluteManifestPath = /^https?:\/\//i.test(manifestPath)
    ? manifestPath
    : apiBaseUrl
      ? `${apiBaseUrl}${manifestPath}`
      : manifestPath;

  const manifestUrl = `${absoluteManifestPath}${
    absoluteManifestPath.includes('?') ? '&' : '?'
  }${query.toString()}`;

  return {
    ...data,
    manifestUrl,
  };
}

export async function stopCameraHls(sessionId: string): Promise<void> {
  const normalized = String(sessionId ?? '').trim();
  if (!normalized) return;

  try {
    await api.post(`/app/cameras/hls/${encodeURIComponent(normalized)}/stop`);
  } catch {
    // best-effort cleanup
  }
}
